export class LogMessage {
    timestamp: Date;
    level: number;
    source: string;
    message: string;
    object: any | null;

    constructor(partial: { level: number, source: string, message: string, object?: any }) {
        this.timestamp = new Date();
        this.level = partial.level;
        this.source = partial.source;
        this.message = partial.message;
        this.object = partial.object;
    }
}
